export const INVESTIGATION_STATUS = {
  REQUESTED: "REQUESTED",
  SCHEDULED: "SCHEDULED",
  PENDING_GM: "PENDING_GM",
  RETURNED: "RETURNED",
  APPROVED: "APPROVED",
  CANCELLED: "CANCELLED",
};

export const STATUS_LABELS = {
  REQUESTED: "طلب فتح تحقيق",
  SCHEDULED: "محدد الموعد",
  PENDING_GM: "بانتظار المدير العام",
  RETURNED: "مرتجع للتعديل",
  APPROVED: "معتمد",
  CANCELLED: "ملغى",
};

export const DECISION_LABELS = {
  PENALTY: "جزاء",
  WARNING: "لفت نظر",
  NONE: "لا يستحق جزاء",
};

export const SOURCE_LABELS = {
  COMPLAINT_REQUEST: "من شكوى",
  HR_DIRECT: "فتح مباشر",
};

export const FILTERS = [
  { id: "all", label: "الكل" },
  { id: "REQUESTED", label: "طلبات" },
  { id: "SCHEDULED", label: "مجدولة" },
  { id: "PENDING_GM", label: "بانتظار المدير" },
  { id: "RETURNED", label: "مرتجعة" },
  { id: "APPROVED", label: "معتمدة" },
  { id: "CANCELLED", label: "ملغاة" },
];

export function statusLabel(status) {
  return STATUS_LABELS[status] || status || "—";
}

export function decisionLabel(decision) {
  return DECISION_LABELS[decision] || "";
}

export function penaltyOutcomeLabel(item) {
  if (item?.penaltyApplied === true) return "حصل على جزاء";
  if (item?.penaltyApplied === false) return "بدون جزاء";
  return "";
}

export function formatSession(item) {
  if (!item?.sessionDate) return "لم يُحدد موعد بعد";
  const date = new Date(`${item.sessionDate}T00:00:00Z`);
  const label = Number.isNaN(date.getTime())
    ? item.sessionDate
    : date.toLocaleDateString("ar-EG", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
        timeZone: "UTC",
      });
  if (item.sessionStart && item.sessionEnd) {
    return `${label} من ${item.sessionStart} إلى ${item.sessionEnd}`;
  }
  return label;
}

export function formatParticipantLine(person, fallbackSession) {
  if (!person?.name) return "";
  const session = {
    sessionDate: person.sessionDate || fallbackSession?.sessionDate,
    sessionStart: person.sessionStart || fallbackSession?.sessionStart,
    sessionEnd: person.sessionEnd || fallbackSession?.sessionEnd,
  };
  const when = session.sessionDate ? formatSession(session) : "";
  return when ? `${person.name} — ${when}` : person.name;
}

export function participantNames(item, kind) {
  return (item?.participants || [])
    .filter((person) => person.kind === kind)
    .map((person) => person.name)
    .filter(Boolean);
}

export function participantScheduleLines(item, kind) {
  return (item?.participants || [])
    .filter((person) => person.kind === kind)
    .map((person) => formatParticipantLine(person, item))
    .filter(Boolean);
}

export function getApiErrorMessage(err, fallback) {
  const message = err?.response?.data?.message;
  if (Array.isArray(message)) return message.join("\n");
  if (typeof message === "string" && message.trim()) return message;
  return err?.message || fallback;
}
